import React, { useEffect, useState } from 'react';
import { Dimmer, Label, Loader } from 'semantic-ui-react';
import {
  AttachmentWrapper
} from '~/pages/Dairy/Newsletter/CreateEditNewsletter/LangTab/Attachments/style';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import NewsletterService from '~/api/services/newsletter';
import { b64toBlob, handleErrors } from '~/utils/helpers';
import Dialog from '~/components/Dialog';

interface Props {
  attachments: any
}

const ShowAttachments: React.FC<Props> = ({ attachments }): JSX.Element => {
  const { t } = useTranslation();
  const { id } = useParams()
  const [fileSource, setFileSource] = useState(null);
  const [languageAttachments, setLanguageAttachments] = useState(null);
  const [isBusy, setIsBusy] = useState(false);

  useEffect(() => {
    setLanguageAttachments(attachments);
  }, []);

  const handleDownloadPdf = async (fileName) => {
    setIsBusy(true);
    try {
      const response = await NewsletterService.getFileNewsletter(id, { fileName: fileName });
      const type = response.data.split(';')[0].split('data:')[1]
      const blob = b64toBlob(response.data, type);
      const blobUrl = URL.createObjectURL(blob);
      setFileSource(blobUrl);

    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false);
  };

  const getFileName = (attachment) => {
    return attachment?.originalFilename;
  }

  const renderModalPreviewFile = () => {
    return <Dialog
      open={Boolean(fileSource)}
      handleClose={() => setFileSource(null)}
      textContent={<iframe width='100%' height='100%' src={fileSource}></iframe>}
      textHeader={t('Preview')}
      textClose={t('Close')}
      type={'preview'}
    />
  };

  return (
    <>
      <Dimmer inverted active={isBusy}>
        <Loader isLoading={isBusy} />
      </Dimmer>
      {languageAttachments?.map((attachment) => (
        <AttachmentWrapper key={attachment.id}>
          {
            Boolean(getFileName(attachment)) &&
            <div style={{ margin: '1em', marginLeft: 0 }}>
              <Label
                onClick={() => handleDownloadPdf(attachment?.attachment)}
                color='blue'
                as='a'
                content={getFileName(attachment)}
                icon='file'
              />
            </div>
          }
        </AttachmentWrapper>
      ))}
      {fileSource && renderModalPreviewFile()}
    </>
  );
};

export default ShowAttachments;
